import { render, staticRenderFns } from "./ProjectsRegisterTab.vue?vue&type=template&id=1e71b761&scoped=true"
import script from "./ProjectsRegisterTab.vue?vue&type=script&lang=js"
export * from "./ProjectsRegisterTab.vue?vue&type=script&lang=js"
import style0 from "./ProjectsRegisterTab.vue?vue&type=style&index=0&id=1e71b761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e71b761",
  null
  
)

export default component.exports